import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { searchMovies, setQuery } from "./searchActions";
import MovieCard from "../movie/MovieCard";
import Spinner from "../../components/Spinner";

const SearchResults = (props) => {
  const dispatch = useDispatch();
  const { query, results, totalResults, page, loading, error } = useSelector(
    (s) => s.search
  );

  // Read query from URL on mount
  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const q = params.get("q");
    if (q && q !== query) {
      dispatch(setQuery(q));
      dispatch(searchMovies(q));
    }
    // eslint-disable-next-line
  }, [props.location.search]);

  const loadMore = () => {
    dispatch(searchMovies(query, page + 1));
  };

  const hasMore = results.length < totalResults;

  return (
    <div className="container mt-4">
      {query && (
        <h4 className="mb-4 text-muted">
          Results for "<strong>{query}</strong>"
          {totalResults > 0 && (
            <small className="ml-2">({totalResults} found)</small>
          )}
        </h4>
      )}

      {loading && results.length === 0 && <Spinner />}

      {error && results.length === 0 && (
        <div className="text-center mt-5">
          <i className="fas fa-search fa-3x text-muted mb-3 d-block"></i>
          <h5 className="text-muted">{error}</h5>
        </div>
      )}

      <div className="movie-grid">
        {results.map((movie) => (
          <MovieCard key={movie.imdbID} movie={movie} />
        ))}
      </div>

      {hasMore && !loading && (
        <div className="text-center my-4">
          <button className="btn btn-outline-light btn-lg" onClick={loadMore}>
            Load More
          </button>
        </div>
      )}

      {loading && results.length > 0 && <Spinner />}
    </div>
  );
};

export default SearchResults;
